import { atom, useRecoilState } from "recoil";

export const addNotesModalState = atom({
    key: 'addNotesModal',
    default: false
});

export const showNotesState = atom({
    key: 'showNotes',
    default: false
});

export default function useLogNotes() {
    const [addNotesModal, setAddNotesModal] = useRecoilState(addNotesModalState);
    const [showNotes, setShowNotes] = useRecoilState(showNotesState);

    const handleAddNotes = (showNotes) => {
        setShowNotes(showNotes);
        setAddNotesModal(true);
    };
    
    return {
        addNotesModal, 
        setAddNotesModal,
        showNotes, 
        setShowNotes,
        handleAddNotes
    }
}